import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormHelper } from '@common/form-helper';
import { CardComponent } from '@components/card/card.component';
import { TreatmentOrderAgreements } from '@models/treatment-types/treatment-order-agreements.model';

@Component({
  selector: 'app-order-agreements',
  templateUrl: './order-agreements.component.html',
  styleUrls: ['./order-agreements.component.scss'],
  imports: [ReactiveFormsModule, CardComponent],
})
export class OrderAgreementsComponent extends FormHelper implements OnInit, OnDestroy {
  @Input() public orderAgreements!: TreatmentOrderAgreements;
  @Input() public parentForm!: FormGroup;

  public agreementsForm: FormGroup;

  /**
   * Builds the agreements form group and registers it in the parent form.
   */
  public ngOnInit(): void {
    this.agreementsForm = new FormGroup({});

    this.orderAgreements.agreements.forEach((_orderAgreement, index) =>
      this.agreementsForm.addControl(`agreement_${index}`, new FormControl(false, Validators.requiredTrue)),
    );

    this.parentForm.addControl('agreements', this.agreementsForm);
  }

  /**
   * Removes the agreements form group from the parent form on destruction.
   */
  public ngOnDestroy(): void {
    this.parentForm.removeControl('agreements');
  }
}
